import React from 'react';
import { Input, Typography } from 'antd';
import Draggable from 'react-draggable';
import './StickyNote.css';

const { Title } = Typography;

const StickyNote = ({ chiefComplaint, setChiefComplaint, otherNotes, setOtherNotes }) => {
  return (
    <Draggable cancel="input, textarea, .ant-input">
      <div className="sticky-note">
        <Title level={5} style={{ marginTop: 0 }}>
          Enter Chief Complaint
          {/* <span style={{ color: 'red' }}>*</span> */}
        </Title>
        <Input.TextArea
          placeholder="Chief Complaint (Mandatory)"
          value={chiefComplaint}
          onChange={(e) => setChiefComplaint(e.target.value)}
          rows={5}
          style={{ marginBottom: '10px' }}
        />
        <Title level={5} style={{ marginTop: 0 }}>
          Enter any other notes
        </Title>
        <Input.TextArea
          placeholder="Any other notes (Optional)"
          value={otherNotes}
          onChange={(e) => setOtherNotes(e.target.value)}
          rows={5}
        />
      </div>
    </Draggable>
  );
};

export default StickyNote;
